export default __webpack_public_path__ + "static/media/exit-up.af74e009.svg";